import {
  Component,
  Inject,
  Input,
  LOCALE_ID,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';


import {ActivatedRoute, Router} from '@angular/router';
import {SnackBarToastyService} from '@Common/widgets/general/snack-bar/snack-bar-toasty.service';
import {SnackBarDataModel} from '@Common/widgets/general/snack-bar/snack-bar-data.model';
import {typeToast} from '@Common/widgets/general/snack-bar/snack-bar-toasty-type.enum';

import {debounceTime, distinctUntilChanged, filter, finalize, switchMap} from 'rxjs/operators';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {MatDialog} from '@angular/material/dialog';
import {MatRadioChange} from '@angular/material/radio';
import {MatSelectChange} from '@angular/material/select';
import {MatStepper} from '@angular/material/stepper';

import {forkJoin, Observable, Subject, Subscription} from 'rxjs';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {StepperSelectionEvent} from '@angular/cdk/stepper';
import {EntiteService, FilesUtils, Individu, IndividuService, PubSubService} from '@Common/core/services';
import {RouterExtService} from '@Services/base/router/router.service';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {Entite} from '@Services/gestion-universite/entite/entite.model';
import {EntiteTreeNode} from '@Services/gestion-universite/entite-tree-node/entite-tree-node.model';
import {EntiteTreeNodeService} from '@Services/gestion-universite/entite-tree-node/entite-tree-node.service';
import {LdapUser} from '@Services/ldap/ldap/ldap-user.model';
import * as moment from 'moment';
import {TreeLazyComponent} from '@Common/widgets/general/tree-lazy/tree-lazy.component';
import {DataBaseTreeModel} from '@Common/widgets/general/tree-lazy/data-base-tree.model';
import {SubSink} from '@Common/core/utils/subsink';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {SafeHtmlPipe} from '@Common/widgets/pipes';
import {DossierValidator} from 'app/dar/gestion/common/DossierValidator';
import {PieceJointe} from 'app/dar/common/services/pieces-jointes/piece-jointe.model';
import {CategoriesService, CodesAnalytiquesService, ConventionsService, CRService, Dossiers, FileTypeEnum, fileTypeEnumLabel,
  fileTypeEnumLabelJoin, getListReference, IntitulesService, ListReference, LolfModel, LOLFService, MotivationsService, PopulationEnum,
  RemunerationsService, SCRService, StateEnum, Transitions, UBService} from 'app/dar/common/services';
import {DarDossiersService} from 'app/dar/common/services/dossiers/dossiers.service';
import {ManageRoleDarService} from 'app/dar/common/services/roles/manage-roles.service';
import {CodesAnalytiquesTreeModel} from 'app/dar/common/services/codes-analytiques/codes-analytiques-tree.model';
import {PiecejointeService} from 'app/dar/common/services/pieces-jointes/piecejointe.service';
import {CodesAnalytiquesModel} from 'app/dar/common/services/codes-analytiques/codes-analytiques.model';
import {FieldsCompleteEnum} from 'app/dar/dossier/edit-stepper/fieldsComplete.enum';
import {CommentTypeEnum} from 'app/dar/common/services/enums/commentTypeEnum';
import {rolesDar} from 'app/dar/common/services/roles/roles-dar';
import {RemunerationEnum} from 'app/dar/common/services/enums/remunerationEnum';
import {CommentsModel} from 'app/dar/common/services/comments/comments.model';
import {UbCrScr} from 'app/dar/common/services/imputations-budgetaires/ub-cr-scr.model';
import {SearchEntiteArboComponent} from 'app/dar/common/search-entite-arbo/search-entite-arbo.component';
import {SearchEntiteComponent} from 'app/dar/common/search-entite/search-entite.component';
import {DecisionEnum} from 'app/dar/common/services/workflow/decision-commission.enum';
import {FilePreviewModaleComponent} from 'app/dar/common/file-preview-modale/file-preview-modale.component';
import {DateHelperService} from 'app/dar/common/services/date-helper/date-helper.service';
import {MatDrawer} from "@angular/material/sidenav";
import {observationsHistoriqueEnum} from "../../../common/services/enums/observationsHistoriqueEnum";

interface HelperPieceJointe {
  uploaderConnector: Subject<any>;
  fileToUpload: PieceJointe;
  attachedFile: PieceJointe;
}

@Component({
  selector: 'app-edit-stepper-content',
  templateUrl: './edit-stepper-content.component.html',
  styleUrls: ['./edit-stepper-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditStepperContentComponent extends DossierValidator implements OnInit, OnChanges, OnDestroy {
  @Input() dossier: Dossiers;
  @Input() retourAuthorized: boolean;
  @Input() openComment = false;

  @ViewChild('ctsread', { static: true }) ctsread: MatDrawer;

  private MAX_FILE_SIZE = 5;
  stateEnum = StateEnum;
  commentTypeEnum = CommentTypeEnum;
  rolesDarEnum = rolesDar;
  remunerationEnum = RemunerationEnum;
  typeFileEnum = FileTypeEnum;
  populationEnum = PopulationEnum;
  extraParams: Map<string, string> = new Map<string, string>();
  comments: CommentsModel[] = [];
  piecesJointes: { [id: number]: HelperPieceJointe; } = {};
  commentType: number = null;
  observationsHistoriqueEnum = observationsHistoriqueEnum;

  transitions: Transitions[] = [];

  /**
   * Listes références
   */
  motivations: ListReference[] = [];
  intitules: ListReference[] = [];
  categories: ListReference[] = [];

  /**
   * Orga budgétaire Cocktail
   */
  conventions: UbCrScr[] = [];
  ubs: UbCrScr[] = [];
  crs: UbCrScr[] = [];
  scrs: UbCrScr[] = [];

  // lolfs: ListReference[] = [];
  lolfs: LolfModel[] = [];
  lolfs_childrens: any[] = [];

  codes_analytiques: CodesAnalytiquesTreeModel[] = [];

  ca_childrens: CodesAnalytiquesTreeModel[] = null;
  operations: Observable<any>;

  lolf_search: Observable<LolfModel[]>;
  codes_analytiques_search: Observable<CodesAnalytiquesModel[]>;

  convention_obj_temp: any;

  /**
   * Structures univ
   */
  dir_cmp: Entite[] = [];
  svc_dep: Entite[] = [];
  labos: Entite[] = [];

  /**
   * Choix type_demande
   */
  typesDemandes: ListReference[] = [
    {id: 2, label: 'BIATOSS'},
    {id: 4, label: 'Enseignant'}];

  /**
   * Choix type de Rémunération
   *
   * Les 2 sont valables pour les BIATOSS ou Enseignants
   *
   * Indicaire : contractuel / ATER
   * Horaire : vacation
   */
  remunerations: ListReference[] = [
    {id: RemunerationEnum.indiciaire, label: 'Indiciaire'},
    {id: RemunerationEnum.horaire, label: 'Horaire'}];

  /**
   * Le dossier est-il en mode modification ou création ?
   */
  isUpdateMode = false;

  /**
   * Pour filtres des listes de référence
   */
  filterPopulation: PopulationEnum = PopulationEnum.aucun;

  /**
   * STEPPER dossier
   */
  @ViewChild('stepper', {static: true}) stepper: MatStepper;

  /**
   * Groupes formulaire / stepper
   */
  typeRecrutFormGroup: UntypedFormGroup;
  posteFormGroup: UntypedFormGroup;
  imputationBudgetFormGroup: UntypedFormGroup;
  affectationFormGroup: UntypedFormGroup;
  periodeFormGroup: UntypedFormGroup;
  filesFormGroup: UntypedFormGroup;
  operation_form = new UntypedFormControl();

  lolf_form = new UntypedFormControl();
  code_analytique_form = new UntypedFormControl();

  /**
   * la date minimum pour la date de début (>= 2020)
   */
  minDateDebut = new Date(2020, 0, 1);

  /**
   * la date minimum pour la date de fin (>= date début)
   */
  minDate = null;

  /**
   * Année imputation budgé. conventions
   * Par défaut, l'année en cours
   */
  annee = null;

  /**
   * URL de retour liste
   */
  previousUrl;

  /**
   * Entité sélectionnée pour Dir / Cmp ou Svc / Dep / Lab
   */
  entiteDirCmpSelected: EntiteTreeNode;

  /**
   * Le type population a-t-il été positionné ?
   */
  validationPopulation = false;

  /**
   * Les champs saisis ou non, pour barre de progression et bouton de passage d'étape à "dipefas"
   */
  progressFields: Map<FieldsCompleteEnum, boolean> = new Map<FieldsCompleteEnum, boolean>([
    [FieldsCompleteEnum.motivation, false],
    [FieldsCompleteEnum.categorie, false],
    [FieldsCompleteEnum.intitule_poste, false],
    [FieldsCompleteEnum.intitule_poste_autre, false],
    [FieldsCompleteEnum.remuneration, false],
    [FieldsCompleteEnum.dir_cmp, false],
    [FieldsCompleteEnum.date_debut, false],
    [FieldsCompleteEnum.date_fin, false],
    [FieldsCompleteEnum.vacation, false],
    [FieldsCompleteEnum.quotite, false],
    [FieldsCompleteEnum.fiche_poste, false],
  ]);

  subscriptions: Subscription[] = [];
  subSink = new SubSink();

  expandLdap = true;

  readonly currentYear: number;

  @ViewChild('treecodes') treecodes: TreeLazyComponent<CodesAnalytiquesTreeModel>;

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    public dateSvc: DateHelperService,
    private sanitized: DomSanitizer,
    private router: Router, private route: ActivatedRoute,
    private dialog: MatDialog, private formBuilder: UntypedFormBuilder,
    private routerSvc: RouterExtService, private fileUtils: FilesUtils,
    private pubSubSvc: PubSubService, public individuSvc: IndividuService, private snackSvc: SnackBarToastyService,
    private entiteService: EntiteService, private entiteTreeNodeService: EntiteTreeNodeService,
    public dossierSvc: DarDossiersService, private roleDarSvc: ManageRoleDarService,
    private motivationsSvc: MotivationsService, private intitulesSvc: IntitulesService, private categoriesSvc: CategoriesService,
    private remunerationsSvc: RemunerationsService, private conventionsSvc: ConventionsService, private ubSvc: UBService,
    private crSvc: CRService, private scrSvc: SCRService, private lolfSvc: LOLFService,
    private pieceJointeService: PiecejointeService,
    public codes_analytiquesSvc: CodesAnalytiquesService) {
    super(dossierSvc, individuSvc);

    const today = new Date();
    this.currentYear = today.getFullYear();
  }

  ngOnInit() {
    this.previousUrl = this.routerSvc.getPreviousUrl();
    this._initPiecesJointes(); // to run before _initDossierIfUpdate

    this._initAnnee();
    this._initHasRole();

    this._initStepperFormGroup();

    this._initListsReferences();
    this._initDossierIfUpdate();
    this._initListsGFC();

    this._initOpeationFormSearch();

    this._initLolfFormSearch();
    this._initCodeAnalytiqueFormSearch();

    if (this.openComment) {
      this.ctsread.toggle();
    }
  }

  /**
   * Affichage commentaires selon role et statut dar
   */

  showComments(): Observable<boolean> {
    return this.shouldShowComments(this.dossier);
  }

  /**
   * Mapping CodesAnalytiquesTreeModel => CodesAnalytiquesModel
   * @param code
   * @private
   */
  private _mapToCodesAnalytiquesModel(code: CodesAnalytiquesTreeModel) {
    return <CodesAnalytiquesModel>{
      can_id: Number(code.id),
      can_code: code.code,
      can_libelle: code.label
    };
  }

  /**
   * Mapping CodesAnalytiquesModel en CodesAnalytiquesTreeModel pour l'affichage dans le tree-lazy
   * @param {DataBaseTreeModel} _nodeParent
   * @param _data données issus de l'API cliente (codes_analytiquesSvc.getBase / getByParent)
   */
  mapToCodesAnalytiquesTreeModel = (_nodeParent: DataBaseTreeModel, _data: CodesAnalytiquesModel[]) => {
    return _data.map(code =>
      <CodesAnalytiquesTreeModel>{
        id: code.can_id.toString(),
        code: code.can_code,
        label: code.can_libelle,
        hasChildren: code.hasChildren > 0,
        level: _nodeParent ? _nodeParent.level + 1 : 1,
        expandable: code.hasChildren > 0
      });
  }

  _initAnnee() {
    this.annee = this.currentYear;
  }

  switchYearLastYear(checked: boolean) {
    this.annee = (checked) ? this.currentYear - 1 : this.currentYear;
    this.resetSelection();
    this._initOpeationFormSearch();
    this._initListsGFC();
  }

  /**
   * Autocompletion sur la recherche des opérations / conventions
   * @private
   */
  _initOpeationFormSearch() {
    this.operations = this.operation_form.valueChanges
      .pipe(
        debounceTime(400), distinctUntilChanged(),
        filter(searchTerm => searchTerm && searchTerm.length >= 3),
        switchMap(data => {
          const extra = {'annee_session': this.annee};
          return this.conventionsSvc.search(data, extra);
        }));
  }

  /**
   * Autocompletion sur la recherche des lolfs
   * @private
   */
  _initLolfFormSearch() {
    this.lolf_search = this.lolf_form.valueChanges
      .pipe(
        debounceTime(400), distinctUntilChanged(),
        filter(searchTerm => searchTerm && searchTerm.length >= 3),
        switchMap(data => {
          const filters: Map<string, string> = new Map<string, string>([['lolf_active', 'true']]);
          return this.lolfSvc.search(data, filters);
        }));
  }

  /**
   * Autocompletion sur la recherche des codes analytiques
   * @private
   */
  _initCodeAnalytiqueFormSearch() {
    this.codes_analytiques_search = this.code_analytique_form.valueChanges
      .pipe(
        // finalize(() => this.pubSubSvc.publish('loading', false)),
        debounceTime(400), distinctUntilChanged(),
        filter(searchTerm => searchTerm && searchTerm.length >= 3),
        switchMap(data => {
          return this.codes_analytiquesSvc.search(data);
        }));
  }

  /***
   * Place holder upload de fichiers
   * @param {FileTypeEnum} type
   */
  getFileTitle(type: FileTypeEnum) {
    const label = fileTypeEnumLabel(type);
    return `${label} : `;
  }

  getFilePlaceholder(type: FileTypeEnum): SafeHtml {
    const sp: SafeHtmlPipe = new SafeHtmlPipe(this.sanitized);
    return sp.transform(fileTypeEnumLabelJoin(type, this.dossier.type_demande === PopulationEnum.biatoss, this.MAX_FILE_SIZE));
  }

  /**
   * Picto du fichier
   * @param pj
   */
  getPicto(pj) {
    return this.fileUtils.getPictoFromExtension(pj);
  }

  /**
   * Choix de la population : après confirmation, on sauvegarde le dossier et on passe à l'étape suivante
   * @param event
   */
  onChangeTypeDemande(event: MatRadioChange) {
    const population = event.value === PopulationEnum.biatoss ? 'BIATOSS' : 'enseignant';
    const data = new DialogData();
    data.title = 'Confirmation cible de demande';
    // tslint:disable-next-line:max-line-length
    data.message = `Vous souhaitez effectuer une demande pour un "${population}", confirmez-vous ce choix ? (vous ne pourrez le changer par la suite)`;

    const dialogRef = this.dialog.open(DialogValidationComponent, {data: data});
    dialogRef.updatePosition({top: '40px'});
    this.subscriptions.push(dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.save();
        this.validationPopulation = true;
        this.nextPoste();
        this.onPopulationChanged(event);
      } else {
        this.typeRecrutFormGroup.patchValue({type_demande: null});
      }
    }));
  }

  /***
   * On fixe INM ou cout estimé en valeur entière
   * On garde si NULL ou undefined (non rempli) => NULL en base
   * Une valeur ne peut < 0 => null le cas échéant
   * @param valueInput valeur à traiter
   * @param {'inm' | 'cout_estime'} type : champ INM ou cout estimé
   * @private
   */
  private _setInmOrCoutEstime(valueInput, type: 'inm' | 'cout_estime') {
    let _value = null;
    if (valueInput ?? false) {
      _value = Number(Number(valueInput).toFixed(0));
      if (_value < 0) {
        _value = null;
      }
    }
    this.dossier[type] = _value;
  }
  /**
   * Prise en compte emploi venant de forms-ms-sbtcp component (fondement, n° emploi, coût, décompte)
   * Arrondi en entier
   * Uniquement pris en compte quand les champs du component form-ms-sbtcp sont éditables app-form-ms-sbtcp
   *   (effet de bord, qd des champs sont disabled, la valeur envoyé est ... "vide" NaN)
   * @param event
   */
  emploiUpdated(event) {
    // voir FormMsSbtcpComponent._switchNumeroCout
    // numero_emploi: depend de event.canEditEmploi
    // cout_estime: depend de event.canEditEmploi
    // inm: depend de event.canEditEmploi
    // plafond_emploi: ne dépend pas de event.canEditEmploi
    // fondement_juridique: ne dépend pas de event.canEditEmploi
    if (event) {
      if (event.canEditEmploi) {
        this.dossier.numero_emploi = event.numero_emploi === '' ? null : event.numero_emploi;
        this._setInmOrCoutEstime(event.cout_estime, 'cout_estime');
        this._setInmOrCoutEstime(event.inm, 'inm');
      }
      this.dossier.plafond_emploi = event.plafond_emploi === '' ? null : event.plafond_emploi;
      this.dossier.fondement_juridique = event.fondement_juridique;
    }
  }

  /**
   * Sélection de l'utilisateur LDAP => remplissage des 2 champs prénom et nom
   * @param ldap
   */
  onSelectLastOccupant(ldap: LdapUser) {
    if (ldap && ldap.sn && ldap.givenName) {
      this.posteFormGroup.patchValue({
        last_occupant_first_name: ldap.givenName[0],
        last_occupant_last_name: ldap.sn[0]
      });

      this.expandLdap = false;
    }
  }

  /**
   * Obtient le libellé à afficher pour la dir/cmp ou svc/dep/lab ToString()
   * @param entite
   */
  getLabelEntite(entite: EntiteTreeNode) {
    let label = `${entite.name}`;

    if (entite.code_manque) {
      label = `${label} (${entite.code_manque})`;
    } else {
      label = `${label} (${entite.code})`;
    }

    return label;
  }

  /**
   * Set entité Dir/Cmp ou Svc/Dep/Labo après recherche et choix d'une entité dans la modale
   * @param _entite
   * @param typeSearch
   * @private
   */
  private _setEntiteSelected(_entite, typeSearch = 'dircmp') {
    if (_entite) {
      if (typeSearch === 'dircmp') {
        this.deleteSelectionAffectation();

        this.entiteDirCmpSelected = _entite;
        this.affectationFormGroup.controls['dir_cmp'].patchValue(_entite.id);
        this.affectationFormGroup.controls['dir_cmp_label'].patchValue(this.getLabelEntite(_entite));
      }

      if (typeSearch === 'svcdep') {
        this.affectationFormGroup.controls['svc_dep'].patchValue(_entite.id);
        this.affectationFormGroup.controls['svc_dep_label'].patchValue(this.getLabelEntite(_entite));
      }
    }
  }

  /**
   * Ouverture modale de recherche structure
   * Dir / Composante
   * ou
   * Svc / Dep / Labo
   * @param typeSearch
   */
  openSearchEntiteArbo(typeSearch = 'dircmp') {
    let data = {};

    if (typeSearch === 'svcdep') {
      data = {
        searchBy: typeSearch,
        hasChildren: this.entiteDirCmpSelected.hasChildren,
        parentId: this.affectationFormGroup.value['dir_cmp'],
        parentLabel: this.affectationFormGroup.get('dir_cmp_label').value,
      };
    }
    data = {...data, activated: true};

    const dialogRef = this.dialog.open(SearchEntiteArboComponent, {data: data, width: '1024px', height: '800px'});
    dialogRef.updatePosition({'top': '50px'});
    this.subscriptions.push(dialogRef.afterClosed().subscribe((_entite) => {
      this._setEntiteSelected(_entite, typeSearch);
    }));
  }

  /**
   * Ouverture de la modale pour recherche et sélection de la Dir / Cmp ou Svc / Dep / Labo
   */
  openSearchEntite() {
    const dialogRef = this.dialog.open(SearchEntiteComponent, {width: '600px'});
    dialogRef.updatePosition({'top': '50px'});
    this.subscriptions.push(dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.affectationFormGroup.controls['dir_cmp'].patchValue(result.dir_cmp.id);
        this.affectationFormGroup.controls['svc_dep'].patchValue(result.svc_dep.id);

        this.affectationFormGroup.controls['dir_cmp_label'].patchValue(`${result.dir_cmp.name} (${result.dir_cmp.code})`);
        this.affectationFormGroup.controls['svc_dep_label'].patchValue(`${result.svc_dep.name} (${result.svc_dep.code})`);
      }
    }));
  }

  /**
   * Prise en compte avis
   * @param event
   */
  avisUpdated(event) {
    switch (event.role) {
      case StateEnum.masse_salariale:
        this.dossier.avis_ms = event.value;
        break;
      case StateEnum.sbtcp:
        this.dossier.avis_sbtcp = event.value;
        break;
      case StateEnum.drh:
        this.dossier.avis_drh = event.value;
        break;
    }
  }

  /**
   * Prise en compte commentaire avis
   * @param event
   */
  commentaireUpdated(event) {
    switch (event.role) {
      case StateEnum.masse_salariale:
        this.dossier.commentaire_avis_ms = event.value;
        break;
      case StateEnum.sbtcp:
        this.dossier.commentaire_avis_sbtcp = event.value;
        break;
      case StateEnum.drh:
        this.dossier.commentaire_avis_drh = event.value;
        break;
    }
  }

  /**
   * Prise en compte winpaye
   * @param event
   */
  winpayeUpdated(event) {
    if (event) {
      this.dossier.winpaye_sbtcp_obj = event;
      this.dossier.winpaye_sbtcp = event.id;
    }
  }

  /**
   * Prise en compte observations commission
   * @param event
   */
  observationsUpdate(event) {
    this.dossier.observations_commission = event || null;
  }

  /**
   * Calcul si le type de demande a été sélectionné
   */
  hasTypeDemande() {
    return !(!this.isUpdateMode && !this.validationPopulation);
  }

  /**
   * Titre de la page selon création ou mise à jour dossier
   */
  getTitle() {
    if (this.isUpdateMode) {
      const refDossier = this.dossier.reference ? `(${this.dossier.reference})` : '';
      return `Mise à jour de demande de recrutement ${refDossier}`;
    }

    return 'Nouvelle demande en recrutement';
  }

  /**
   * Ecoute de chaque champ obligatoire pour % de saisie du dossier
   * @private
   */
  _initControlsValuesChanges() {
    this.subscriptions.push(this.posteFormGroup.controls['motivation'].valueChanges.subscribe((_value) => {
      this._ifThenProgress(_value, FieldsCompleteEnum.motivation);
      this._calculateProgressComplete();
      if (this.dossier && this.motivations) {
        const currentMotiv = this.posteFormGroup.controls['motivation'].value;
        if (currentMotiv !== this.dossier.motivation) {
          // Force la maj de motivation_obj pour provoquer une changement de app-button-transitions.hasINMRecrutement
          // et recalculer les transitions avec la prise en compte du parametrage de la dernierre motivation
          this.dossier.motivation = currentMotiv;  // motivation.id
          this.dossier.motivation_obj = this.motivations.find((motiv) => motiv.id === currentMotiv);
        }
      }
    }));

    this.subscriptions.push(this.posteFormGroup.controls['intitule_poste'].valueChanges.subscribe((_value) => {
      this._ifThenProgress(_value, FieldsCompleteEnum.intitule_poste);
      this._calculateProgressComplete();
    }));

    this.subscriptions.push(this.posteFormGroup.controls['intitule_poste_autre'].valueChanges
      .pipe(debounceTime(150))
      .subscribe((_value) => {
        this._ifThenProgress(_value, FieldsCompleteEnum.intitule_poste_autre);
        this._calculateProgressComplete();
      }));

    this.subscriptions.push(this.posteFormGroup.controls['categorie_equivalence'].valueChanges.subscribe((_value) => {
      this._ifThenProgress(_value, FieldsCompleteEnum.categorie);
      this._calculateProgressComplete();
    }));
    this.subscriptions.push(this.periodeFormGroup.controls['remuneration'].valueChanges.subscribe((_value) => {
      if (_value === RemunerationEnum.indiciaire) {
        this.periodeFormGroup.patchValue({vacation_horaires: 0});
      }

      if (_value === RemunerationEnum.horaire) {
        this.periodeFormGroup.patchValue({quotite: 0});
      }

      this._ifThenProgress(_value, FieldsCompleteEnum.remuneration);
      this._calculateProgressComplete();
    }));

    this.subscriptions.push(this.affectationFormGroup.controls['dir_cmp'].valueChanges.subscribe((_value) => {
      this._ifThenProgress(_value, FieldsCompleteEnum.dir_cmp);
      this._calculateProgressComplete();
    }));

    this.subscriptions.push(this.periodeFormGroup.controls['date_debut'].valueChanges.subscribe((_value) => {
      this._ifThenProgress(_value, FieldsCompleteEnum.date_debut);
      this._calculateProgressComplete();
    }));

    this.subscriptions.push(this.periodeFormGroup.controls['date_fin'].valueChanges.subscribe((_value) => {
      this._ifThenProgress(_value, FieldsCompleteEnum.date_fin);
      this._calculateProgressComplete();
    }));

    this.subscriptions.push(this.periodeFormGroup.controls['quotite'].valueChanges
      .pipe(debounceTime(150))
      .subscribe((_value) => {
        if (_value && (_value > 0 && _value <= 100)) {
          this._ifThenProgress(_value, FieldsCompleteEnum.quotite);
        } else {
          this._ifThenProgress(null, FieldsCompleteEnum.quotite);
        }
        this._calculateProgressComplete();
      }));

    this.subscriptions.push(this.periodeFormGroup.controls['vacation_horaires'].valueChanges
      .pipe(debounceTime(150))
      .subscribe((_value) => {
        if (_value && _value > 0) {
          this._ifThenProgress(_value, FieldsCompleteEnum.vacation);
        } else {
          this._ifThenProgress(null, FieldsCompleteEnum.vacation);
        }
        this._calculateProgressComplete();
      }));
  }

  /**
   * Init Form et des forms groups
   * @private
   */
  _initStepperFormGroup() {
    this.typeRecrutFormGroup = this.formBuilder.group({
      type_demande: ['', Validators.required]
    });

    this.posteFormGroup = this.formBuilder.group({
      motivation: [],
      motif: [],
      last_occupant_first_name: ['', Validators.maxLength(80)],
      last_occupant_last_name: ['', Validators.maxLength(80)],
      intitule_poste: [],
      intitule_poste_autre: [],
      categorie_equivalence: []
    });

    this.imputationBudgetFormGroup = this.formBuilder.group({
      convention: [],
      ub: [],
      cr: [],
      scr: [],
      code_lolf: [],
      code_analytique: [],
      operation: [],
    });

    this.affectationFormGroup = this.formBuilder.group({
      dir_cmp_label: [],
      dir_cmp: [],
      svc_dep_label: [],
      svc_dep: [],
      labo: [],
      localisation: ['']
    });

    this.affectationFormGroup.controls['dir_cmp_label'].disable();
    this.affectationFormGroup.controls['svc_dep_label'].disable();

    this.periodeFormGroup = this.formBuilder.group({
      remuneration: [],
      date_debut: [],
      date_fin: [],
      duree: new UntypedFormControl({value: '', disabled: true}),
      quotite: [0, [Validators.min(1), Validators.max(100)]],
      vacation_horaires: ['', Validators.pattern('^\\d+$')]
    });

    this.filesFormGroup = this.formBuilder.group({});

    this._initControlsValuesChanges();
  }

  /**
   * soit dte du dateChange($event) ou appel explicite avec une date
   * @param dte
   * @param {string} control : le contrôle appelant (date début ou date fin)
   */
  onDateSelected(dte: MatDatepickerInputEvent<Date>, control = '') {
    const dateDebut = this.periodeFormGroup.controls['date_debut'].value;
    let dateFin = this.periodeFormGroup.controls['date_fin'].value;

    if (dateDebut) {
      this.minDate = dateDebut;
    }

    if (dateFin < dateDebut) {
      dateFin = null;
      this.periodeFormGroup.patchValue({date_fin: dateFin});
      this.periodeFormGroup.patchValue({duree: null});
      this.toasty(`La date de fin n'est pas valide`);
    }

    if (dateDebut && dateFin) {
      const nbDays = this.dossierSvc.getDaysBetweenDates(dateDebut, dateFin);
      if (nbDays > 0) {
        this.periodeFormGroup.patchValue({duree: nbDays});
      }
    }
  }

  /**
   * Les fichiers ont été uploadés, action à entreprendre
   * @param pjs
   */
  handleFilesUploaded(pjs: PieceJointe[]) {
    if (pjs && pjs.length > 0) {
      pjs.forEach((_pj) => {
        this.piecesJointes[_pj.type_file].fileToUpload = null;
        this.piecesJointes[_pj.type_file].attachedFile = _pj;
        if (_pj.type_file === FileTypeEnum.poste) {
          if (this.dossier.type_demande === PopulationEnum.biatoss) {
            this._ifThenProgress(this.piecesJointes[FileTypeEnum.poste].attachedFile, FieldsCompleteEnum.fiche_poste);
          }
        }
        this._calculateProgressComplete();
      });
    }
  }

  /**
   * Positionnement du "step" selon le nombre de champs obligatoires (PJ notamment selon BIATOSS / Ens.)
   * @private
   Le nb de champ dépend des valeur saisies, voir _calculateProgressComplete
   */
  // _setStepProgression() {
  //   if (this.dossier) {
  //     if (this.dossier.type_demande === PopulationEnum.biatoss) {
  //       this.step = 100 / this.nb_fields_biatoss;
  //     }
  //
  //     if (this.dossier.type_demande === PopulationEnum.enseignant) {
  //       this.step = 100 / this.nb_fields_enseignant;
  //     }
  //   }
  // }

  /**
   * Initialisation du dossier en update
   * (isUpdate, transitions, mapping dossier => form, init phs, etc)
   * @param {Dossiers} dossier
   * @param {boolean} goStepOne : doit-on se possitionner à l'étape Poste ?
   * @private
   */
  _initDossierUpdate(goStepOne = true) {
    this.isUpdateMode = true;
    this.filterPopulation = this.dossier.type_demande || PopulationEnum.aucun;

    // this._setStepProgression();
    this._initTransitionsDossier(this.dossier.uuid);

    this._mapDossierToFormGroupValues(this.dossier, goStepOne);

    this.validationPopulation = this.dossier.type_demande &&
      (this.dossier.type_demande === PopulationEnum.biatoss || this.dossier.type_demande === PopulationEnum.enseignant);
  }

  /**
   * Initialise le dossier dans le cas d'une mise à jour
   * @private
   */
  private _initDossierIfUpdate() {
    if (this.dossier.id !== 0) {
      this._initDossierUpdate();
    }
  }

  /**
   * Le type de population est-il positionné ?
   */
  isAlreadyPopulationChecked() {
    return !!this.dossier.type_demande;
  }

  /**
   * Sélection du type de population =>
   * @param event
   */
  onPopulationChanged(event: MatRadioChange) {
    this.filterPopulation = event.value;
    this.typeRecrutFormGroup.patchValue({type_demande: event.value});
    this.dossier.type_demande = event.value;
    this._initListsReferences();
  }

  /**
   * Transformation Date string (YYYY-MM-DD => Date())
   * TODO : peut-on ne pas utiliser moment ?
   * @param dt
   */
  getDateFromString(dt: string) {
    return this.dossierSvc.getDateFromString(dt);
  }

  /**
   * Init des valeurs avec le dossier trouvé vers les forms groups
   * Selon, désactivation de champs
   * @param {Dossiers} dossier : le dossier
   * @param {boolean} goStepOne : doit-on se positionner sur l'étape poste ?
   */
  private _mapDossierToFormGroupValues(dossier: Dossiers, goStepOne = true) {
    this.typeRecrutFormGroup.patchValue({type_demande: dossier.type_demande});

    if (dossier.type_demande) {
      if (goStepOne) {
        // tslint:disable-next-line:max-line-length
        // Voir à faire l'assignation ailleurs (cycle commponent), sans le timeout : cdkStepper: Cannot assign out-of-bounds value to `selectedIndex`
        setTimeout(() => {
          if (this.stepper._steps && this.stepper._steps.length > 1) {
            this.stepper.selectedIndex = 1;
          }
        });
      }

      this.filterPopulation = dossier.type_demande;
      this._initListsReferences();
    }

    if (dossier.attachedfiles_obj.length > 0) {
      this._initPjs(dossier.attachedfiles_obj);
    }

    this.posteFormGroup.patchValue({
      motivation: dossier.motivation,
      motif: dossier.motif,
      last_occupant_first_name: dossier.last_occupant_first_name,
      last_occupant_last_name: dossier.last_occupant_last_name,
      intitule_poste: dossier.intitule_poste,
      intitule_poste_autre: dossier.intitule_poste_autre,
      categorie_equivalence: dossier.categorie_equivalence
    });

    const dtDebut = this.getDateFromString(dossier.date_debut);
    const dtFin = this.getDateFromString(dossier.date_fin);

    this.periodeFormGroup.patchValue({
      remuneration: dossier.remuneration,
      date_debut: dtDebut,
      date_fin: dtFin,
      quotite: dossier.quotite,
      vacation_horaires: dossier.vacation_horaires
    });

    const nbDays = this.dossierSvc.getDaysBetweenDates(dtDebut, dtFin);
    if (nbDays > 0) {
      this.periodeFormGroup.patchValue({duree: nbDays});
    }

    /**
     * sauf en création, à partir de commission les champs de la periode ne sont plus modifiables
     * la simulation du coût se retrouve dans date_valide, cout_valide, etc
     * ou pour certains roles (ms, sbtcp, drh, commission) elle l'est avant commission
     * **/
    if (this.dossier.state !== StateEnum.demande &&
      this.dossierSvc.isDisablePeriode(dossier.state, this.rolesConnecte)) {
      this.periodeFormGroup.disable();
    }

    if (dossier.dir_cmp) {
      const getEntite$ = this.entiteService.get(dossier.dir_cmp);
      const getEntiteTreeNode$ = this.entiteTreeNodeService.get(dossier.dir_cmp);

      this.subscriptions.push(forkJoin([getEntite$, getEntiteTreeNode$])
        .subscribe(_data => {
          this.entiteDirCmpSelected = _data[1];
          this.affectationFormGroup.patchValue({
            dir_cmp_label: `${_data[0].name} (${_data[0].code})`
          });
        }));
    }

    if (dossier.svc_dep) {
      this.subscriptions.push(this.entiteService.get(dossier.svc_dep).subscribe((_data) => {
        this.affectationFormGroup.patchValue({
          svc_dep_label: `${_data.name} (${_data.code})`
        });
      }));
    }

    this.affectationFormGroup.patchValue({
      dir_cmp: dossier.dir_cmp,
      svc_dep: dossier.svc_dep,
      labo: dossier.labo,
      localisation: dossier.localisation
    });

    if (dossier.convention_obj) {
      this.convention_obj_temp = dossier.convention_obj;
    }

    this._calculateProgression(dossier);
  }

  /**
   * Set à true / false selon s'il y a une valeur saisie pour tel champ
   * @param value
   * @param field
   * @private
   */
  private _ifThenProgress(value, field: FieldsCompleteEnum) {
    if (value) {
      this.progressFields.set(field, true);
    } else {
      this.progressFields.set(field, false);
    }
  }

  /**
   * Set / Unset selon si tel champ a été saisi et ensuite la progression sur le dossier chargé
   * @param dossier
   * @private
   */
  private _calculateProgression(dossier: Dossiers) {
    this._ifThenProgress(dossier.motivation, FieldsCompleteEnum.motivation);
    this._ifThenProgress(dossier.intitule_poste, FieldsCompleteEnum.intitule_poste);
    this._ifThenProgress(dossier.intitule_poste_autre, FieldsCompleteEnum.intitule_poste_autre);
    this._ifThenProgress(dossier.categorie_equivalence, FieldsCompleteEnum.categorie);
    this._ifThenProgress(dossier.dir_cmp, FieldsCompleteEnum.dir_cmp);

    this._ifThenProgress(dossier.remuneration, FieldsCompleteEnum.remuneration);
    if (dossier.remuneration) {
      if (dossier.remuneration === RemunerationEnum.indiciaire) {
        this._ifThenProgress(dossier.quotite, FieldsCompleteEnum.quotite);
        this._ifThenProgress(null, FieldsCompleteEnum.vacation);
        // this._ifThenProgress(dossier.vacation_horaires, FieldsCompleteEnum.vacation);
        // this._ifThenProgress(null, FieldsCompleteEnum.quotite);
      }

      if (dossier.remuneration === RemunerationEnum.horaire) {
        this._ifThenProgress(dossier.vacation_horaires, FieldsCompleteEnum.vacation);
        this._ifThenProgress(null, FieldsCompleteEnum.quotite);
        // this._ifThenProgress(dossier.quotite, FieldsCompleteEnum.quotite);
        // this._ifThenProgress(null, FieldsCompleteEnum.vacation);
      }
    }

    this._ifThenProgress(dossier.date_debut, FieldsCompleteEnum.date_debut);
    this._ifThenProgress(dossier.date_fin, FieldsCompleteEnum.date_fin);

    if (dossier.type_demande === PopulationEnum.biatoss) {
      this._ifThenProgress(this.piecesJointes[FileTypeEnum.poste].attachedFile, FieldsCompleteEnum.fiche_poste);
    }

    this._calculateProgressComplete();
  }

  /**
   * Calcul taux de progression selon champs saisis
   * @private
   */
  private _calculateProgressComplete() {
    // remuneration est obligatoire et vaut Indiciaire ou Horaire
    // pour Indiciaire, le champ vacation est pris en compte
    // pour Horaire, le champ quotite est pris en compte
    // Ces 2 champs ne sont pas nécessaire en même temps => nbFields-1
    // voir _calculateProgression
    let nbFields = this.progressFields.size - 1;
    // si le poste est un Enseignant, la fiche de poste n'est pas obligatoire
    // La valeur de la fiche de poste dans progressFields est mise à true uniquement pour un biatoss
    // lors du calcul de progress, la value sera toujours false pour un enseignant
    // voir _calculateProgression
    if (this.dossier.type_demande === PopulationEnum.enseignant) {
      --nbFields;
    }
    // si le poste n'est pas Autre, le champ intitule_poste_autre est à ne pas prendre en compte
    const intituleAutre = this.intitules.find(
      (intitule) =>
        intitule.label === 'Autre, merci de remplir le champ texte à droite.'
    );
    const intituleSelectedIsAutre = this.posteFormGroup.controls['intitule_poste'].value === intituleAutre?.id;
    if (!intituleSelectedIsAutre) {
      --nbFields;
    }

    let progress = 0;
    this.progressFields.forEach((value, key) => {
      if(FieldsCompleteEnum.intitule_poste_autre !== key || intituleSelectedIsAutre) {
        // Le champ intitule_poste_autre est pris en compte si intituleAutre vaut autre
        if (value) {
          ++progress;
        }
      }
    });
    console.log("_calculateProgressComplete: ", progress ,nbFields);
    this.progressComplete = Math.round((progress * 100) / nbFields);
  }

  /**
   * Liste des transitions pour le dossier à partir de son état courant
   * @param {number} uuid dossier
   * @private
   */
  private _initTransitionsDossier(uuid) {
    this.subscriptions.push(this.dossierSvc.listTransitions(uuid).subscribe((transitions) => {
      this.transitions = transitions;
    }));
  }

  /**
   * Gestion de l'affectation
   */
  deleteSelectionAffectation() {
    this.affectationFormGroup.controls['dir_cmp'].patchValue(null);
    this.affectationFormGroup.controls['dir_cmp_label'].patchValue('');

    this.affectationFormGroup.controls['svc_dep'].patchValue(null);
    this.affectationFormGroup.controls['svc_dep_label'].patchValue('');
  }

  /**
   * Confirmation suppression d'une dir / cmp
   */
  onDeleteSDConfirm(event) {
    const data = new DialogData();
    data.title = 'Confirmation suppression affectation';
    data.message = `Souhaitez-vous supprimer la sélection pour la direction/composante et service/département ?`;

    const dialogRef = this.dialog.open(DialogValidationComponent, {data: data});
    dialogRef.updatePosition({top: '40px'});
    this.subscriptions.push(dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteSelectionAffectation();
      }
    }));
  }

  /**
   * Y a-t-il une direction ou composante de saisie ?
   */
  hasDirectionComposanteValue() {
    return this.affectationFormGroup.value['dir_cmp'] && this.affectationFormGroup.value['dir_cmp'] > 0;
  }

  compareFn(v1, v2): boolean {
    return v1 && v2 ? v1.id === v2.id : v1 === v2;
  }

  /**
   * Init des listes références motivations, intitulés de postes, catégories / équivalences
   * @private
   */
  private async _initListsReferences() {
    this.motivations = await getListReference(this.motivationsSvc, this.filterPopulation, {id: null, label: ''});
    this.intitules = await getListReference(this.intitulesSvc, this.filterPopulation, {id: null, label: ''});
    this.categories = await getListReference(this.categoriesSvc, this.filterPopulation, {id: null, label: ''});
  }

  private _initListsGFC() {
    this.getUbs(this.annee);
    this.getLolfsBase();
    this.getCABase();
  }

  /**
   * Obtient le libellé de la décision commission
   * @param decision
   */
  public getDecision(decision: DecisionEnum) {
    return this.dossierSvc.getDecision(this.dossier);
  }
  /**
   * Exécution du toaster
   * @param msg
   * @param title
   * @param type
   */
  public toasty(msg: string, title: string = '', type: typeToast = typeToast.success) {
    const config: SnackBarDataModel = {
      title: title,
      message: msg,
      type: type,
      showClose: true
    };

    this.snackSvc.openSnackToasty(config);
  }
  public nextPoste() {
    this.stepper.next();
  }

  public nextImputation() {
    this.stepper.next();
  }

  public nextAffectation() {
    this.stepper.next();
  }

  public nextPeriode() {
    this.stepper.next();
  }

  public nextFiles() {
    this.stepper.next();
  }

  isInCommission() {
    return this.dossier &&
      (this.dossier.state === StateEnum.commission || this.dossier.state === StateEnum.commission_decision);
  }

  /**
   * Mise à jour dossier avec les valeurs calculées de la calculatrice
   * @param data
   */
  public onCalculateCommission(data) {
    this.dossier.cout_valide = data.cout_valide;
    this.dossier.date_debut_validee = this.dateSvc.transformDateToYYYYMMDD(data.date_debut_validee);
    this.dossier.date_fin_validee = this.dateSvc.transformDateToYYYYMMDD(data.date_fin_validee);
    this.dossier.quotite_validee = data.quotite_validee;
    this.dossier.vacation_horaires_validee = data.vacation_horaires_validee;
  }

  /**
   * Mapping forms groups vers le dossier
   * les dates et la durée sont calculées spécifiquement
   * @param group le form group à traiter
   * @param {string[]} properties : liste des controls du groupe à mapper vers le dossier
   * @private
   */
  private _mapFormsToDossier(group, properties: string[]) {
    properties.forEach((property) => {
      if (group.value[property] === '') {
        group.value[property] = null;
      }

      if ((property === 'date_debut' || property === 'date_fin') && group.value[property]) {
        this.dossier[property] = this.dateSvc.transformDateToYYYYMMDD(moment(group.value[property].valueOf()));
      } else {
        if (property === 'duree' && group.value['date_debut'] && group.value['date_fin']) {
          this.dossier[property] = this.dossierSvc.getDaysBetweenDates(group.value['date_debut'], group.value['date_fin']);
        } else {
          this.dossier[property] = group.value[property];
        }
      }
    });
  }

  /**
   * Lancement de l'upload des fichiers
   * @param _dossier
   * @private
   */
  private _uploaderLaunch(_dossier) {
    Object.values(this.piecesJointes).forEach((value) => {
      if (value.fileToUpload) {
        value.fileToUpload.dossier = _dossier.id;
        value.uploaderConnector.next(value.fileToUpload);
      }
    });
  }

  /**
   * Mapping des valeurs form controls vers dossier, pour sauvegarde
   * @private
   */
  private _mapAllFormToDossier() {
    this._mapFormsToDossier(this.typeRecrutFormGroup, ['type_demande']);
    this._mapFormsToDossier(this.posteFormGroup, ['motivation', 'motif',
      'last_occupant_first_name', 'last_occupant_last_name',
      'intitule_poste', 'intitule_poste_autre',
      'categorie_equivalence']);
    this._mapFormsToDossier(this.periodeFormGroup, ['remuneration', 'date_debut', 'date_fin', 'quotite', 'vacation_horaires', 'duree']);
    this._mapFormsToDossier(this.affectationFormGroup, ['dir_cmp', 'svc_dep', 'labo', 'localisation']);
  }

  onDeletedFile(pj: PieceJointe) {
    this.piecesJointes[pj.type_file].attachedFile = null;
    if (pj.type_file === FileTypeEnum.poste) {
      if (this.dossier.type_demande === PopulationEnum.biatoss) {
        this._ifThenProgress(this.piecesJointes[FileTypeEnum.poste].attachedFile, FieldsCompleteEnum.fiche_poste);
      }
    }
    this._calculateProgressComplete();
  }

  /**
   * Confirmation de suppression de PJ
   * @param pj
   * @param typeFile
   */
  public deletePJ(pj: PieceJointe, typeFile: FileTypeEnum) {
    const data = new DialogData();
    data.title = 'Confirmation de suppression de fichier';
    data.message = `Souhaitez vous supprimer la pièce jointe (${pj.name}) du dossier ? `;
    const dialogRef = this.dialog.open(DialogValidationComponent, {data: data});
    dialogRef.updatePosition({top: '40px'});
    this.subscriptions.push(dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.pieceJointeService.delete(pj).subscribe(() => {
          // recalcul progression fiches poste / financière
          this.piecesJointes[typeFile].fileToUpload = null;
          this.piecesJointes[typeFile].attachedFile = null;
          if (typeFile === FileTypeEnum.poste) {
            if (this.dossier.type_demande === PopulationEnum.biatoss) {
              this._ifThenProgress(this.piecesJointes[typeFile].attachedFile, FieldsCompleteEnum.fiche_poste);
            }
          }
          this._calculateProgressComplete();
          this.toasty(`La pièce jointe (${pj.name}) a bien été supprimé du dossier`);
        });
      }
    }));
  }

  /**
   * Click Sauvegarde du dossier sans passage de transition
   * @param msg
   * @param toasty
   */
  public save(msg: string = '', toasty: boolean = true) {
    this.pubSubSvc.publish('loading', true);

    msg = 'Dossier bien sauvegardé';
    const sub = this.saveApi()
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((_dossier) => {
        this._uploaderLaunch(_dossier);
        if (toasty) {
          this.toasty(msg);
          this.dossier = _dossier;
          this._initDossierUpdate(false);
        }
      });

    this.subscriptions.push(sub);
  }

  /**
   * Sauvegarde du dossier
   * - mapping form => dossier
   * - appel update ou create selon
   * @return {Observable<Dossiers>} observable
   */
  private saveApi(): Observable<Dossiers> {
    this._mapAllFormToDossier();

    if (this.isUpdateMode) {
      return this.dossierSvc.update(this.dossier, 'uuid');
    } else {
      return this.dossierSvc.create(this.dossier);
    }
  }

  /**
   * Passage à l'état suivant :
   *   - sauvegarde
   *   - puis exécution de l'exécution de la transition
   * @param data
   */
  public saveAndNextStep(data) {
    const step = data.transition;
    const message = data.message;

    this.pubSubSvc.publish('loading', true);

    const sub = this.saveApi().subscribe((_dossier) => {
      this._uploaderLaunch(_dossier);

      this.dossierSvc.changeState(this.dossier.uuid, step)
        .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
        .subscribe((_d) => {
          const step_label = message.replace('_', ' ');
          this.toasty(`Le dossier a été bien envoyé (${step_label})`);
          this.golist();
        });
    });

    this.subscriptions.push(sub);
  }

  /**
   * Retour à la liste, calcul selon la route précédente (liste origine)
   */
  public golist() {
    if (this.previousUrl) {
      this.router.navigate([this.previousUrl]);
    } else {
      this.router.navigate(['/']);
    }
  }

  public onStepChanged(event: StepperSelectionEvent) {
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  /**
   * Init PJs du dossier
   * @param pjs
   * @private
   */
  private _initPjs(pjs: PieceJointe[]) {
    if (pjs && pjs.length > 0) {
      for (const pj of pjs) {
        this.piecesJointes[pj.type_file].attachedFile = pj;
      }
    }
  }

  // /**
  //  * Est-ce un PDF | PNG | JPG
  //  * @param file
  //  */
  // canPreview(file: PieceJointe) {
  //   if (file && file.filename) {
  //     const ext = file.filename.split('.').pop();
  //     if (ext && (ext.toLowerCase() === 'png' || ext.toLowerCase() === 'jpg' ||
  //       ext.toLowerCase() === 'jpeg' || ext.toLowerCase() === 'pdf')) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  // /**
  //  * Preview image ou PDF
  //  * @param file
  //  */
  // popUpPreviewImage(file: PieceJointe) {
  //   this.subscriptions.push(this.pieceJointeService.getFile(file.id).subscribe(data => {
  //     if (data) {
  //       this.popUp(data);
  //     }
  //   }));
  // }

  // popUp(_blob: any) {
  //   const dialogRef = this.dialog.open(FilePreviewModaleComponent, {
  //     data: _blob
  //   });
  // }

  /**
   * Gestion des  Ub / Cr / Scr / Conventions, opérations
   * @param annee
   */
  public getUbs(annee: number): void {
    this.subscriptions.push(this.conventionsSvc.getUbs(annee).subscribe(
      (ubs) => {
        this.ubs = ubs;
      }
    ));
  }

  public getCrs(annee: number, event): void {
    this.subscriptions.push(this.conventionsSvc.getCrs(annee, event.value).subscribe(
      (crs) => {
        this.crs = crs;
      }
    ));
  }

  public getSousCrs(annee: number, event): void {
    this.subscriptions.push(this.conventionsSvc.getSousCrs(annee, event.value.ub, event.value.cr).subscribe(
      (scrs) => {
        this.scrs = scrs;
      }
    ));
  }

  public getOperation(annee: number, event): void {
    this.subscriptions.push(this.conventionsSvc.getOperation(annee, event.value.ub, event.value.cr, event.value.scr).subscribe(
      (operation) => {
        this.conventions = operation;
        if (this.conventions.length === 1) {
          this.onSelection(this.conventions[0]);
        }
      }
    ));
  }

  /**
   * Convention / opération sélection
   * @param obj
   */
  public onSelection(obj): void {
    this.convention_obj_temp = obj;
    this.dossier.convention = obj.id;
    this.dossier.convention_obj = obj;
  }

  /**
   * Code analytique sélection
   * @param obj
   */
  public onSelectionCodeAnalytique(obj): void {
    this.dossier.code_analytique = obj.can_id;
    this.dossier.code_analytique_obj = obj;
  }

  /**
   * Lolf sélection
   * @param {LolfModel} lolf
   */
  public onSelectionLolf(lolf: LolfModel): void {
    this.dossier.code_lolf = lolf.id;
    this.dossier.code_lolf_obj = lolf;
  }

  onSelectionLolfSelect(event: MatSelectChange) {
    this.onSelectionLolf(event.value);
  }

  public resetSelection() {
    this.conventions = [];
    this.crs = [];
    this.scrs = [];
    this.operation_form.reset('');
    this.code_analytique_form.reset('');
    this.imputationBudgetFormGroup.patchValue({ub: null});
    this.imputationBudgetFormGroup.patchValue({cr: null});
    this.imputationBudgetFormGroup.patchValue({scr: null});
    this.imputationBudgetFormGroup.patchValue({convention: null});
    this.convention_obj_temp = null;
  }

  /**
   * Gestion GFC : Lolfs
   */
  public getLolfsBase(): void {
    const filters: Map<string, string> = new Map<string, string>([['lolf_active', 'true']]);
    this.subscriptions.push(this.lolfSvc.listAllItems(filters).subscribe((_lolfs) => {
      this.lolfs = _lolfs.list;
    }));
  }
  public setLolf(obj): void {
    this.dossier.code_lolf = obj.id;
    this.dossier.code_lolf_obj = obj;
  }

  public resetLolfSelection() {
    this.dossier.code_lolf = null;
    this.dossier.code_lolf_obj = [];
  }

  private _codeAnalytiqueTreeModel(item) {
    return <CodesAnalytiquesTreeModel>{
      id: item.can_id,
      code: `${item.can_code}`,
      label: `${item.can_libelle}`,
      hasChildren: item.hasChildren,
      expandable: item.hasChildren > 0
    };
  }

  public getCABase(): void {
    this.subscriptions.push(this.codes_analytiquesSvc.getBase().subscribe(
      (data) => {
        this.codes_analytiques = data.map(item => this._codeAnalytiqueTreeModel(item));
      }
    ));
  }

  public setCA(obj: CodesAnalytiquesTreeModel): void {
    if (obj) {
      const code = this._mapToCodesAnalytiquesModel(obj);
      this.dossier.code_analytique = code.can_id;
      this.dossier.code_analytique_obj = code;
    }
  }

  public resetCASelection() {
    this.dossier.code_analytique = null;
    this.dossier.code_analytique_obj = [];
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
    if (this.subscriptions) {
      this.subscriptions.forEach((_sub) => {
        if (_sub) {
          _sub.unsubscribe();
        }
      });
    }
  }

  private _initPiecesJointes() {
    this.piecesJointes[FileTypeEnum.poste] = {uploaderConnector: new Subject(), fileToUpload: null, attachedFile: null};
    this.piecesJointes[FileTypeEnum.financiere] = {uploaderConnector: new Subject(), fileToUpload: null, attachedFile: null};
    this.piecesJointes[FileTypeEnum.autre] = {uploaderConnector: new Subject(), fileToUpload: null, attachedFile: null};
    this.piecesJointes[FileTypeEnum.pi] = {uploaderConnector: new Subject(), fileToUpload: null, attachedFile: null};
    this.piecesJointes[FileTypeEnum.cvitale] = {uploaderConnector: new Subject(), fileToUpload: null, attachedFile: null};
    this.piecesJointes[FileTypeEnum.rib] = {uploaderConnector: new Subject(), fileToUpload: null, attachedFile: null};
    this.piecesJointes[FileTypeEnum.dombank] = {uploaderConnector: new Subject(), fileToUpload: null, attachedFile: null};
    this.piecesJointes[FileTypeEnum.casier] = {uploaderConnector: new Subject(), fileToUpload: null, attachedFile: null};
    this.piecesJointes[FileTypeEnum.cv] = {uploaderConnector: new Subject(), fileToUpload: null, attachedFile: null};
  }
  onDemandeurUpdated() {
    this.golist();
  }
}
